import { AuthUser } from 'src/@types/auth';

export const checkOnboarding = (user: AuthUser) => {
  const isOnboarding =
    user?.tenants?.length === 0 ||
    (Array.isArray(user?.tenants) &&
      (user?.tenants[0].publications === undefined || user?.tenants[0].publications?.length === 0));
  return isOnboarding;
};
